import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchMtrStructSubDetail(id) {
  const { data: raw } = await request.get(`/mtr-struct-sub/${id}`);
  return parseVer4DetailResponse(raw);
}
